import { render, staticRenderFns } from "./PremiumPageCourseVideo.vue?vue&type=template&id=d6c3377c&"
import script from "./PremiumPageCourseVideo.vue?vue&type=script&lang=js&"
export * from "./PremiumPageCourseVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports